<button
  type="button"
  class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
  (click)="toggleCriticalFilter()"
  [ngClass]="{
    'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isCriticalFilterEnabled(),
    'border-primary-blue bg-background-white': !isCriticalFilterEnabled()
  }"
>
  <span class="typo-h7-semibold">{{ 'health_history_filter_critical_label' | translate }}</span>
</button>
<button
  type="button"
  class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
  (click)="toggleActiveFilter()"
  [ngClass]="{
    'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isActiveFilterEnabled(),
    'border-primary-blue bg-background-white': !isActiveFilterEnabled()
  }"
>
  <span class="typo-h7-semibold">{{ 'health_history_filter_active_label' | translate }}</span>
</button>
